/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import Divider from "@mui/material/Divider";
import SimpleFooter from "./components/SimpleFooter";
// Home page sections

// Home page components
import Episodes from "./components/Episodes";
import FAQSection from "./components/FAQ";
import FeaturesOne from "./components/FeaturesOne";
import Testimonials from "./components/Testimonials";
// Routes
import footerRoutes from "footer.routes";
// PageHeaders page components
import Counters from "./sections/Counters";
import HeaderOne from "./sections/HeaderOne";
import Profile from "./sections/Profile";
// Images

function Home() {
  return (
    <>
      <MKBox display="flex" flexDirection="column" bgColor="dark">
        <HeaderOne></HeaderOne>
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          {/** How does it work */}
          <FeaturesOne></FeaturesOne>
          <Divider
            variant="middle"
            sx={{ marginLeft: "25%", marginRight: "25%", bgcolor: "text.main" }}
          />
          {/** Episodes */}
          <Episodes></Episodes>
          <Divider
            variant="middle"
            sx={{ marginLeft: "25%", marginRight: "25%", bgcolor: "text.main" }}
          />
          {/** Testimonials */}
          <Testimonials></Testimonials>
          <Divider
            variant="middle"
            sx={{ marginLeft: "25%", marginRight: "25%", bgcolor: "text.main" }}
          />
          {/** How to get involved */}
          <Counters></Counters>
          <Divider
            variant="middle"
            sx={{ marginLeft: "25%", marginRight: "25%", bgcolor: "text.main" }}
          />

          {/** FAQs */}
          <FAQSection></FAQSection>
          <Divider
            variant="middle"
            sx={{ marginLeft: "25%", marginRight: "25%", bgcolor: "text.main" }}
          />

          {/** Meet the Founder */}
          <Profile></Profile>
        </Card>
        <MKBox pt={6} px={1} mt={6} mb={5}>
          <SimpleFooter content={footerRoutes} light />
        </MKBox>
      </MKBox>
    </>
  );
}

export default Home;
